import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'

export enum TaskTemplateTypeId {
  RESERVATION = 'reservation',
  RECURRING = 'recurring',
}

export class TaskTemplateType extends Codebook<TaskTemplateTypeId> {
  static readonly RESERVATION = new TaskTemplateType(
    TaskTemplateTypeId.RESERVATION,
    () => $t('taskTemplateType.reservation'),
    'list-check',
  )

  static readonly RECURRING = new TaskTemplateType(
    TaskTemplateTypeId.RECURRING,
    () => $t('taskTemplateType.recurring'),
    'arrows-rotate',
  )

  private constructor(
    id: TaskTemplateTypeId,
    public readonly name: () => string,
    public readonly icon: string,
  ) {
    super(id)
  }
}
